// Query-key factory for the admin Email Templates surface. Lives in its own
// *Keys file so the stale-after-save convention recognises it (the gate skips
// files matching /[Kk]eys\.tsx?$/) and every mutation can invalidate the whole
// surface by the `all` prefix.
//
// The list's per-template counts (customised / drafted / current version) are
// derived from the very rows a draft or publish writes, so a mutation on ONE
// template legitimately changes the LIST too — which is why the mutations
// invalidate by prefix rather than by detail key.

export const emailTemplateKeys = {
  all: ["email-templates"] as const,
  list: () => ["email-templates", "list"] as const,
  detail: (key: string) => ["email-templates", "detail", key] as const,
};
